export default {
  path: '/course',
  component: () => import('../../views/course/course-router.vue'),
  children: [
    {
      path: '',
      name: 'Course',
      component: () => import('../../views/course/pages/Course.vue'),
      meta: {
        name: 'navigationDrawer.course',
        icon: '/icons/course.svg',
        auth: true
      }
    },
    {
      path: 'course-create',
      name: 'CourseCreate',
      component: () => import('../../views/course/pages/CourseCreate.vue'),
      meta: {
        name: 'navigationDrawer.course',
        icon: '/icons/course.svg',
        auth: true
      }
    },
    {
      path: 'course-edit/:id',
      name: 'CourseEdit',
      component: () => import('../../views/course/pages/CourseEdit.vue'),
      meta: {
        name: 'navigationDrawer.course',
        icon: '/icons/course.svg',
        auth: true
      }
    },
    {
      path: 'course-detail/:id',
      name: 'CourseDetail',
      component: () => import('../../views/course/pages/CourseDetail.vue'),
      meta: {
        name: 'navigationDrawer.course',
        icon: '/icons/course.svg',
        auth: true
      }
    }
  ]
}
